import * as React from "react";

// Vector redraw of the previous Amazon Ads icon, using its original background color.
const SvgAmazonAds = (props, ref) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...{ ...props, ref }}
  >
    <rect width="32" height="32" fill="#0F141A" />
    <g transform="translate(-0.75 0)" fill="#fff">
      <path d="M3.5 13.1c-.4-.3-.8.1-.4.5 6.6 6.5 16.1 8.3 24 2.4.7-.5.2-1.1-.4-.7-7.6 4.8-16 2.7-23.2-2.2Z" />
      <path d="M24.8 13.7c-.5.3-.5.8.1.7 1.5-.3 3.2-.4 3.5.1.3.6-.8 3.1-1.2 4-.2.5.1.8.5.4 1.5-1.4 2.9-4.5 2.3-5.4-.6-.9-3.2-1-5.2.2Z" />
    </g>
  </svg>
);

export default React.forwardRef(SvgAmazonAds);
